<template lang="pug">
div.wallet-tab-bar
  AlcorLink.tab-bar-item(
    v-for="{name, to, exact, isNFT, showInNetworks} in urls"
    v-if="!showInNetworks || showInNetworks.includes($store.state.network.name)"
    :class="{'nft-tab': isNFT}"
    :to="to"
    :exact="exact"
    :key="name"
  )
    img(v-if="isNFT" src="~/assets/images/nft-monkey.png", alt="nft-monkey")
    span {{ $t(name) }}
</template>

<script>
import AlcorLink from '../AlcorLink.vue'
export default {
  name: 'WalletTabBar',
  components: { AlcorLink },
  computed: {
    urls() {
      return [
        { name: 'Tokens', to: '/wallet/tokens', exact: true },
        { name: 'Open Orders', to: '/wallet/positions', exact: true },
        { name: 'History', to: '/wallet/history' },
        {
          name: 'NFT’s',
          showInNetworks: ['wax'],
          to: '/wallet/nfts',
        },
        { name: 'Liquidity Pools', to: '/wallet/liquidity_pools' },
        // TODO { name: 'Staking', to: '/wallet/staking' },
        { name: 'Farms', to: '/wallet/farms' },
        { name: 'Resources', to: '/wallet/resources' },
      ]
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.funcScrollTo()
      })
    },
  },
  mounted() {
    this.funcScrollTo()
  },
  methods: {
    funcScrollTo() {
      this.$scrollTo('.wallet-tab-bar .active', {
        container: '.wallet-tab-bar',
        offset: -100,
        x: true,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wallet-tab-bar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  top: 0;
  z-index: 4;
  padding: 4px 0;

  &::-webkit-scrollbar {
    height: 2px;
    width: 2px;
    display: block;
  }

  &::-webkit-scrollbar-thumb {
  }
}

.tab-bar-item {
  flex: 1;
  border-radius: 8px;
  padding: 12px;
  white-space: nowrap;
  min-width: 120px;

  &.nft-tab {
    width: 100%;
    height: 100%;
    position: relative;

    img {
      position: absolute;
      height: 100%;
      max-width: 100%;
    }
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &.active {
    background: var(--background-color-third);
  }
}

@media only screen and (max-width: 940px) {
  .wallet-tab-bar {
    gap: 4px;
  }
  .tab-bar-item {
    padding: 6px 12px;
    font-size: 0.86rem;
    &::v-deep .inner {
      justify-content: flex-start !important;
    }
  }
}
</style>
